import { PaymentCondition } from '../../lib/types/models/payment-condition/payment-condition'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getPaymentCondition(id: number) {
  return restApiClient
    .url(constructApiUrl(API.paymentConditions.get.url, { id }))
    .get<PaymentCondition>()
}
